export default "__VITE_ASSET__373TEADi__"